import { render, staticRenderFns } from "./RespondCard.vue?vue&type=template&id=bccfda84&scoped=true"
import script from "./RespondCard.vue?vue&type=script&lang=js"
export * from "./RespondCard.vue?vue&type=script&lang=js"
import style0 from "./RespondCard.vue?vue&type=style&index=0&id=bccfda84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccfda84",
  null
  
)

export default component.exports